
import { css } from 'lit';
export default css`
/* Apply standardized box sizing to the component. */
:host {
  box-sizing: border-box;
}
:host *,
:host *::before,
:host *::after {
  box-sizing: inherit;
}
/* Apply proper CSS for accessibly hiding elements to each component. */
.visually-hidden {
  position: absolute !important;
  overflow: hidden;
  clip: rect(1px, 1px, 1px, 1px);
  width: 1px;
  height: 1px;
  word-wrap: normal;
}
/* Apply component specific CSS */
:host{
  --shadow:0 0 40px 5px rgba($dark-blue, 0.1);
}
.interactive-document{
  position:relative;
}
.interactive-document .user-markup + .interactive-document__container{
      margin-top:24px;
    }
@media (min-width: 1024px){
.interactive-document .user-markup + .interactive-document__container{
        margin-top:(40px - 4px)
    }
      }
.interactive-document__container{
    position:relative;
  }
.interactive-document__figure{
    box-shadow:var(--shadow);
    position:relative;
    z-index:1;
  }
.interactive-document .btn{
    left:50%;
    position:absolute;
    top:50%;
    transform:translate(-50%, -50%);
    width:calc(100% - (40px * 2));
    z-index:10;
  }
@media (min-width: 1024px){
.interactive-document .btn{
      margin-top:30px
  }
    }
.accordion-wrapper{
  display:flex;
  flex-direction:column;
  gap:var(--spacing-4);
}
@media (min-width: 1024px){
.accordion-wrapper{
    display:none
}
  }
`;